import {Injectable} from '@angular/core';
import {HttpResponse} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {catchError, switchMap, take} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {CoreState} from 'src/app/core/store/reducers';
import {LoadTranslationSuccessAction, selectTranslation} from 'src/app/core/store/translation';
import {TranslationApiService} from 'src/app/modules/i18n/translation-api.service';

interface TranslationApiResponse {
    application: string;
    locale: string;
    translations: { [key: string]: any };
}

@Injectable({
    providedIn: 'root'
})
export class TranslationCacheService {

    constructor(
        private translationApiService: TranslationApiService,
        private store: Store<CoreState>
    ) {
    }

    synchronizeTranslationsForCountry(locale: string): Observable<void> {
        return this.store.select(selectTranslation(locale)).pipe(
            take(1),
            switchMap((cached: any) => this.translationApiService.getTranslations(locale, cached?.timestamp) as Observable<HttpResponse<any>>),
            switchMap((response: any) => {
                if (response.status === 304) {
                    console.log(`[TranslationCacheService] ${locale} à jour (304 Not Modified)`);
                    return of(void 0);
                }
                const etag = response.headers.get('ETag')?.replace(/"/g, '') ?? '';
                const translations = (response.body as TranslationApiResponse)?.translations ?? {};
                console.log(`[TranslationCacheService] Mise à jour de ${locale} (etag: ${etag})`);
                this.store.dispatch(new LoadTranslationSuccessAction({
                    lang: locale,
                    translations: {
                        ...translations,
                        timestamp: etag
                    }
                }));
                return of(void 0);
            }),
            catchError(error => {
                console.error('[TranslationCacheService] Erreur chargement traductions:', error);
                return of(void 0);
            })
        );
    }

    getTranslation(lang: string): Observable<any> {
        return this.store.select(selectTranslation(lang)).pipe(
            take(1),
            switchMap(translation => {
                if (translation) {
                    return of(translation);
                }
                console.error(`[TranslationCacheService] ${lang} non trouvé`);
                return of(void 0);
            })
        );
    }
}
